import type { ComponentProps, ReactElement } from 'react';
import type { BaseIcon } from '@hotjar/hotsauce';
import { IconButton, tokens } from '@hotjar/hotsauce';

import { useTranslation } from '@hotjar/translations';
import { SvgIcon } from '../../FeedbackIcon/icons/SvgIcon';

export interface ContentsquareReplayIconProps {
  url: string;
  onClick: () => void;
}

// RAN-290: This component will be removed in the cleanup for this ticket
export const ContentSquareIcon = ({
  color = tokens.color.primary_cta,
}: {
  color?: string;
}): ReactElement<ComponentProps<typeof BaseIcon>, 'BaseIcon'> => (
  <SvgIcon size="18px" color={color}>
    <path
      d="M17 5.73094L16.8068 5.37167C15.9552 3.76984 14.5648 2.48918 12.8599 1.73612C11.1549 0.983048 9.23474 0.801448 7.40881 1.22058C5.58287 1.63972 3.9576 2.63517 2.79495 4.04647C1.63229 5.45781 1 7.20274 1 9.00001C1 10.7973 1.63229 12.5422 2.79495 13.9535C3.9576 15.3649 5.58287 16.3603 7.40881 16.7794C9.23474 17.1986 11.1549 17.017 12.8599 16.2639C14.5648 15.5108 15.9552 14.2302 16.8068 12.6283L16.9983 12.2683L13.5847 9.00001L17 5.73094ZM15.5749 12.473C14.7773 13.7803 13.552 14.7999 12.0885 15.3741C10.6249 15.9482 9.00454 16.045 7.47774 15.6496C5.95094 15.2541 4.60272 14.3883 3.64139 13.1861C2.68006 11.9838 2.15915 10.5119 2.15915 8.99794C2.15915 7.48394 2.68006 6.01214 3.64139 4.80986C4.60272 3.60759 5.95094 2.74183 7.47774 2.34635C9.00454 1.95087 10.6249 2.0477 12.0885 2.62186C13.552 3.19602 14.7773 4.21556 15.5749 5.52294L12.7643 8.21481L9.36021 4.95561L5.13487 9.00001L9.36021 13.0436L12.7643 9.78441L15.5749 12.473ZM11.9449 9.00001L9.36021 11.474L6.77467 9.00001L9.36021 6.52521L11.9449 9.00001Z"
      strokeWidth="0.3"
    />
  </SvgIcon>
);

export const ContentsquareReplayIcon = ({
  url,
  onClick,
}: ContentsquareReplayIconProps): JSX.Element => {
  const { t } = useTranslation('feedback', { keyPrefix: 'surveys.responses-list.recording' });
  return (
    <IconButton
      size="s"
      kind="ghost"
      description={t('go-to-contentsquare')}
      tooltipText={t('go-to-contentsquare')}
      icon={<ContentSquareIcon />}
      isExternal
      as="a"
      href={url}
      onClick={onClick}
    />
  );
};
